import { render, staticRenderFns } from "./settings-organization-ctia-keyword-auto-responses.vue?vue&type=template&id=6cf12430&scoped=true&"
import script from "./settings-organization-ctia-keyword-auto-responses.vue?vue&type=script&lang=js&"
export * from "./settings-organization-ctia-keyword-auto-responses.vue?vue&type=script&lang=js&"
import style0 from "./settings-organization-ctia-keyword-auto-responses.vue?vue&type=style&index=0&id=6cf12430&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf12430",
  null
  
)

export default component.exports